import * as React from 'react'
import { useSettings } from "ui-seeker/core"
import { getCurrentDateString } from 'ui-seeker/utils'
import { MuiThemeProvider } from "@material-ui/core"

export default function Footer() {
	const { footer } = useSettings()
	const { theme } = footer

	return <MuiThemeProvider theme={theme}>
        <div className="footer flex flex-middle">
            <div className="flex flex-middle container px-sm-30 w-100">
                <span className="m-auto"/>
                <p className="m-0">
                    {getCurrentDateString('yyyy')} &copy; Designed and Developed by Data Seekers
                </p>
            </div>
        </div>
    </MuiThemeProvider>
}